import { useMemo } from "react";
import { useSelector } from "react-redux";

const useBasicInfo = () => {
  const basic = useSelector((store) => store.basic);

  return useMemo(
    () => ({
      ...basic,
      country: basic?.country,
      hasChildren: basic?.hasChildren,
      hasOtherChildren: basic?.hasOtherChildren,
      hasPartner: basic?.hasPartner,
      hasFamily: basic?.hasFamily,
      hasPet: basic?.hasPet,
      incapacityPlan: basic?.incapacityPlan,
    }),
    [basic],
  );
};

export default useBasicInfo;
